module.exports = __webpack_public_path__ + "img/icon-upload.97ab18f0.svg";